import {
	Component, Input, ElementRef, AfterViewInit,
	OnChanges, SimpleChanges
} from '@angular/core';

import { TopoMap, DisplayEdge, DashStyle } from '../../dtos/topology/TopoMap';

@Component({
    selector: 'pen-pattern-viewer',
	templateUrl: './pen-pattern-viewer.component.html',
	styleUrls: ['./pen-pattern-viewer.component.scss']
})
export class PenPatternViewerComponent implements AfterViewInit, OnChanges {

	@Input()
	public width: number;

	@Input()
	public height: number;

	@Input()
	public lineColor: string;

	@Input()
	public lineWidth: number;

	@Input()
	public lineDashStyle: string;

	private canvas: HTMLCanvasElement;

	constructor(private elementRef: ElementRef) {
		this.width = 130;
		this.height = 25;
		this.lineColor = "#000000";
		this.lineWidth = 1;
		this.lineDashStyle = "Solid";
	}

	public ngAfterViewInit(): void {
		this.canvas = <HTMLCanvasElement>this.elementRef.nativeElement.firstElementChild;

		this.canvas.width = this.width;
		this.canvas.height = this.height;

		this.redraw();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.redraw();
	}


	private redraw(): void {
		if (this.canvas) {
			let lineColor: string = this.lineColor;

			let lineWidth: number = 1;
			if (typeof (this.lineWidth) == "number")
				lineWidth = this.lineWidth;
			else if (typeof (this.lineWidth) == "string")
				lineWidth = parseInt(this.lineWidth);

			let lineDashStyle: DashStyle = DashStyle[this.lineDashStyle];
			let lineDash: number[] = DisplayEdge.toDashStyle(lineDashStyle);

			let start = {
				x: 0,
				y: this.canvas.height / 2
			};
			let end = {
				x: this.canvas.width,
				y: this.canvas.height / 2
			}

			let ctx = this.canvas.getContext("2d");
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			ctx.beginPath();
			ctx.strokeStyle = lineColor;
			ctx.lineWidth = lineWidth;
			ctx.setLineDash(lineDash);
			ctx.moveTo(start.x, start.y);
			ctx.lineTo(end.x, end.y);
			ctx.stroke();
		}
	}


}